import React from "react";

// reactstrap components
import {Col, Container, Row, Card, CardBody, CardTitle} from "reactstrap";
import CardHeader from "reactstrap/es/CardHeader";

function SkillsCard() {

    return (
        <>
            <div className="section section-brown text-center">
                <Container>
                    <h2 className="title">Work Experience</h2>
                    <br/>
                    <Row>
                        <Col md="4">
                            <Card className="card-plain text-light">
                                <CardHeader>
                                    <h2>Zeta Global</h2>
                                    <p className="h3">Web Applications Director</p>
                                    <br/>
                                    <p>May 2019 - May 2020</p>
                                </CardHeader>
                            </Card>
                        </Col>
                        <Col md="5">
                            <Card className="card-plain text-light">

                                <CardBody>
                                    <CardTitle className="h3">
                                        Responsibilities
                                    </CardTitle>
                                    <ul className="card-description text-left text-light">
                                        <li>Oversaw the team in charge of the DSP and DMP Web Application.</li>
                                        <li>Coordinated with PM and stakeholders on quarterly deliverables.</li>
                                        <li>Built and developed a high performing Engineering team.</li>

                                    </ul>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <hr />
                    <Row>
                        <Col md="4">
                            <Card className="card-plain text-light">
                                <CardHeader>
                                    <h2>Sizmek</h2>
                                    <p className="h3">Sr. Engineering Manager</p>
                                    <br/>
                                    <p>July 2017 - April 2019</p>
                                </CardHeader>
                            </Card>
                        </Col>
                        <Col md="5">
                            <Card className="card-plain text-light">

                                <CardBody>
                                    <CardTitle className="h3">
                                        Responsibilities
                                    </CardTitle>
                                    <ul className="card-description text-left text-light">
                                        <li>Led a distributed engineering team with five scrum teams across the globe.</li>
                                        <li>Oversaw and coordinated deployments with QA, PM and PMM.</li>
                                        <li>Oversaw the rebranding of an entire application with significant architectural changes and a condensed rollout window.</li>
                                        <li>Brought together distinct companies and got them to converge upon an architecture for shared components across multiple platforms.</li>
                                        <li>Built a high performing team both through new hires and by mentoring existing engineers and managers.</li>
                                        <li>Established processes that increased morale, delivery, and code quality. Ensured that teams involved in the program are properly following processes and that barriers to their success are being removed.</li>
                                        <li>Ensured new features are reusing existing components and adhering to UX standards.</li>
                                    </ul>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <hr />
                    <Row>
                        <Col md="4">
                            <Card className="card-plain text-light">
                                <CardHeader>
                                    <h2>Rocket Fuel Inc.</h2>
                                    <p className="h3">Engineering Manager</p>
                                    <br/>
                                    <p>Jan 2015 - June 2017</p>
                                </CardHeader>
                            </Card>
                        </Col>
                        <Col md="5">
                            <Card className="card-plain text-light">
                                <CardBody>
                                    <CardTitle className="h3">
                                        Responsibilities
                                    </CardTitle>
                                    <ul className="card-description text-left text-light">
                                        <li>Oversaw the Agile Software Development Life Cycle and overall development process flow.</li>
                                        <li>Work with the PMO team to help prioritize projects through the different engineering teams. </li>
                                        <li>Work closely with the different business owners to facilitate technology projects.</li>
                                        <li>Responsible for the definition, coordination and completion of software development programs and projects using agile software development methodologies.</li>
                                        <li>Mentored junior engineers.</li>
                                    </ul>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}

export default SkillsCard;
